/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIslandTropical} from '@fortawesome/pro-duotone-svg-icons';

const SecurityIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faIslandTropical} {...props} />
);

export default SecurityIcon;
